// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';
import { repaint, show, useTemplate } from 'utils/node';

export default component(async (node) => {
  const { overlay, list, itemTemplate } = choozy(node);

  let productSections = [...document.querySelectorAll('[data-product-section-id]')];
  let reviewsSection = productSections.find((section) => section.matches('.yotpo-main-widget'));
  const createItem = useTemplate(itemTemplate);

  if (reviewsSection && !reviewsSection.querySelector('.main-widget')) {
    await new Promise((resolve) => {
      const reviewsMutationObserver = new MutationObserver(([entry], observer) => {
        entry.addedNodes.forEach((addedNode) => {
          if (addedNode.nodeType === Node.ELEMENT_NODE && addedNode?.closest('.main-widget')) {
            resolve();
            observer.disconnect();
          }
        });
      });

      reviewsMutationObserver.observe(reviewsSection, { childList: true, subtree: true });
    });
  }

  const threshold =
    window.innerHeight / 2 / Math.max(...productSections.map((section) => section.scrollHeight));

  const init = () => {
    const menuItems = productSections
      .filter((section) => section.dataset.productSectionName !== '')
      .map((section) =>
        createItem({
          href: `#${section.dataset.productSectionId}`,
          text: section.dataset.productSectionName,
          'data-section': section.dataset.productSectionId,
        }),
      );

    list.append(...menuItems);

    const mainObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          show(node);
          repaint(node);
          node.classList.add('show');
        } else {
          node.classList.remove('show');
        }
      },
      { threshold: 0 },
    );

    mainObserver.observe(productSections[0]);

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        const intersectingEntry = entries.find((entry) => entry.isIntersecting);
        if (intersectingEntry) {
          const { productSectionId } = intersectingEntry.target.dataset;

          menuItems.forEach((item) => {
            item.classList[item.dataset.section === productSectionId ? 'add' : 'remove']('active');
          });
        }
      },
      { threshold },
    );

    productSections.slice(1).forEach((section) => {
      sectionObserver.observe(section);
    });

    const overlayObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === menuItems[menuItems.length - 1]) {
            overlay.classList[entry.isIntersecting ? 'remove' : 'add']('show');
          }
        });
      },
      { threshold: 1.0 },
    );

    overlayObserver.observe(menuItems[menuItems.length - 1]);
  };

  if (productSections[0] && productSections[0].dataset.productNavigationEnabled === 'true') init();

  document.addEventListener('shopify:section:load', () => {
    productSections = [...document.querySelectorAll('[data-product-section-id]')];
    reviewsSection = productSections.find((section) => section.matches('.yotpo-main-widget'));

    if (productSections[0] && productSections[0].dataset.productNavigationEnabled === 'true') {
      list.innerHTML = '';
      init();
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    productSections = [...document.querySelectorAll('[data-product-section-id]')];
    reviewsSection = productSections.find((section) => section.matches('.yotpo-main-widget'));

    if (productSections[0] && productSections[0].dataset.productNavigationEnabled === 'true') {
      list.innerHTML = '';
      init();
    }
  });
});
